import CollectorInfo from './CollectorInfo.js';
export default CollectorInfo;
//# sourceMappingURL=index.js.map